import React from 'react';
import {useAuth} from "../../../helpers/AuthContext";
import CouponForm from "./CouponForm";

function CreateCouponForm({onSuccess, onError}) {
    const {fetch, API_URL} = useAuth();
    const handleSubmit = async (values) => {
        console.log('Form submitted', values);
        try {
            const response = await fetch(API_URL + '/v1/seller/coupons', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(values),
            });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const json = await response.json();
            console.log('Coupon created successfully:', json);
            if (onSuccess) {
                onSuccess(json);
            }
        } catch (error) {
            console.error('Error creating coupon:', error);
            if (onError) {
                onError(error);
            }
        }
    };

    const handleChange = async (values) => {
        console.log('Form values changed', values);
    };
    return (
        <CouponForm
            onSubmit={handleSubmit}
            onChange={handleChange}
            initialValues={{
                type: 'channel',
                isCombinable: 'true',
                dollarAmount: '0',
                percentageAmount: '0',
            }}
        />
    )
}

export default CreateCouponForm;
